<template>
    <div class="leads" v-if="isMounted" v-can="'statistic_lead.access'">
        <ds-filter
            ref="filter"
            ssr
            :default-date="date"
            :fields="fields"
            :data="filtersData"
            :loaded="loader"
            @submit="submitFilter"
            @resetFilter="refreshFilter"
        >
            <vs-col
                vs-w="12"
                vs-sm="12"
                vs-lg="12"
                vs-xs="12"
            >
                <div class="flex items-center">
                    <div class="m-2 flex items-center">
                        <vs-radio v-model="direction" vs-name="send_date" vs-value="send_date">{{ $t('date.send_date') }}</vs-radio>
                    </div>
                    <div class="m-2 flex items-center">
                        <vs-radio v-model="direction" vs-name="created_at" vs-value="created_at">{{ $t('date.created_at') }}</vs-radio>
                    </div>
                    <div class="m-2 flex items-center">
                        <vs-radio v-model="direction" vs-name="first_action_date" vs-value="first_action_date">{{ $t('date.first_action_date') }}</vs-radio>
                    </div>
                </div>
            </vs-col>

            <vs-col
                vs-w="12"
                vs-sm="6"
                vs-lg="3"
                vs-xs="12"
            >
                <div class="m-2">
                    <label class="text-sm opacity-75">{{ $t(`date.${direction}`) }}</label>
                    <date-picker
                        @select="selectedDate"
                        :date="date[direction]"
                        :direction="direction"
                    />
                </div>
            </vs-col>
        </ds-filter>

        <tabs
            :tabs="statusList"
            translate
            panel
            :active-tab="activeTab"
            :loaded="loader"
            @selected="selectedTab"
        >
            <template v-slot:panel>
                <div class="flex items-center pr-2">
                    <div class="flex items-center">
                        <div v-if="statusSystem === 'sended' && !isReindexing && isPermission('statistic_lead.update_status')" class="flex items-center">
                            <vs-button
                                :disabled="activeGlobalStatuses && !statusIds.length"
                                @click="updateGroupStatusOrReindexing('updateStatus')"
                                v-tooltip="$t('tooltip.updateStatus')"
                                class="mr-2"
                                radius
                                type="flat"
                                v-bind="$iconData(!activeGlobalStatuses ? 'icon-command' : 'icon-save', !activeGlobalStatuses ? 'fi-rs-command' : 'fi-rr-disk')"
                            ></vs-button>
                        </div>

                        <div v-if="!activeGlobalStatuses && !activeGlobalToTrash && (isPermission('statistic_lead.update_status') && userState.group === 2)">
                            <vs-button
                                :disabled="isReindexing && !statusIds.length"
                                @click="updateGroupStatusOrReindexing('reindexing')"
                                v-tooltip="$t('tooltip.reindexing')"
                                class="mr-2"
                                radius
                                type="flat"
                                v-bind="$iconData(!isReindexing ? 'icon-refresh-cw' : 'icon-save', !isReindexing ? 'fi-rr-refresh' : 'fi-rr-disk')"
                            ></vs-button>
                        </div>

                        <div v-if="activeGlobalStatuses || isReindexing">
                            <vs-button
                                @click="updateGroupStatusOrReindexingClose"
                                v-tooltip="$t('global.Cancel')"
                                class="mr-2"
                                radius
                                type="flat"
                                color="danger"
                                v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                            ></vs-button>
                        </div>
                    </div>

                    <div v-if="(statusSystem === 'not_valid' || statusSystem === 'hold') && !isReindexing"
                         v-can="'statistic_lead.update'"
                    >
                        <vs-button
                            :disabled="loader || (activeGlobalToTrash && !leadTrashIds.length)"
                            @click="toTrashGlobal(leadTrashIds)"
                            v-tooltip="$t('tooltip.toTrash')"
                            class="mr-2"
                            radius
                            type="flat"
                            v-bind="$iconData('icon-trash-2', 'fi-rr-trash')"
                        ></vs-button>
                    </div>
                    <div v-if="activeGlobalToTrash && (statusSystem === 'not_valid' || statusSystem === 'hold')">
                        <vs-button
                            :disabled="loader"
                            @click="toTrashGlobalClose"
                            v-tooltip="$t('global.Cancel')"
                            class="mr-2"
                            radius
                            type="flat"
                            v-bind="$iconData('icon-x', 'fi-rr-cross-small')"
                            color="danger"
                        ></vs-button>
                    </div>
                    <div>
                        <vs-button
                            :disabled="loader"
                            v-tooltip="$t('tooltip.Refresh_table')"
                            class="mr-2"
                            radius
                            type="flat"
                            v-bind="$iconData('icon-rotate-cw', 'fi-rr-rotate-right')"
                            @click="refreshTable"
                        ></vs-button>
                    </div>

                    <vs-dropdown
                        ref="dropdown"
                        class="cursor-pointer mr-2"
                        vs-custom-content vs-trigger-click
                    >
                        <a class="flex items-center cursor-pointer" href.prevent>
                            <feather-icon class="mr-1" icon="SlidersIcon" svgClasses="h-4 w-4 ml-1"/>
                            <span>{{ $t('global.view') }}</span>
                        </a>

                        <vs-dropdown-menu class="leads_dropdown">
                            <ul>
                                <li class="flex items-center"
                                    v-for="(display, index) of heads"
                                    :key="index"
                                >
                                    <vs-button
                                        radius color="primary"
                                        type="flat"
                                        v-bind="$iconData(display.display ? 'icon-eye' : 'icon-eye-off', display.display ? 'fi-rr-eye' : 'fi-rr-eye-crossed')"
                                        @click="view(display)"
                                    ></vs-button>
                                    <span class="ml-2 mr-4 whitespace-no-wrap">{{ $t(display.name) }}</span>
                                </li>
                            </ul>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <div>
                        <vs-button
                            :disabled="loader"
                            v-can="'statistic_lead.download_leads'"
                            class="ml-2"
                            v-tooltip="$t('tooltip.Download_CSV')"
                            radius
                            type="flat"
                            v-bind="$iconData('icon-download', 'fi-rr-download')"
                            @click="downloadCSV"
                        ></vs-button>
                    </div>
                </div>
            </template>

            <ds-table
                ref="table"
                :data="leads"
                :heads="heads"
                ssr
                spacer
                :view-items="[50, 100, 500]"
                :total="totalNum"
                :max-items="limitNum"
                :page="pageNum"
                :select="isTableSelect"
                select-key="id"
                :disabled="loader"
                @page="page"
                @limit="limit"
                @sort="sort"
                @selected="selectedTable"
            >
                <template v-slot:person="{person}">
                    <div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-user', 'fi-rr-user')"></vs-icon>
                            {{ person.first_name ? person.first_name : '-' }} {{ person.last_name ? person.last_name : '-' }}
                            <vs-icon
                                v-if="isPermission('statistic_lead.comments') && person.status === 'sended'"
                                v-tooltip="$t('tooltip.Comment')"
                                class="cursor-pointer"
                                @click="comments(person)"
                                color="primary"
                                v-bind="$iconData('icon-message-square', 'fi-rr-comment-dots')"
                            />
                            <vs-icon
                                v-if="isPermission('statistic_lead.history_statuses') && person.status === 'sended'"
                                v-tooltip="$t('modals.Lead_history_statuses')"
                                class="cursor-pointer ml-1"
                                @click="getHistoryStatuses(person)"
                                color="primary"
                                v-bind="$iconData('icon-book', 'fi-rr-book')"
                            />
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-mail', 'fi-rr-envelope')"></vs-icon>
                            {{ person.email ? person.email : '-' }}
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-smartphone', 'fi-rr-mobile-notch')"></vs-icon>
                            {{ person.phone ? person.phone : '-' }}
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-map-pin', 'fi-rr-ip-address')"></vs-icon>
                            <div v-if="person.ip">
                                <span v-if="person.detected_ip"
                                      :class="{'leads__detected_ip': person.detected_ip !== person.ip}"
                                      v-tooltip="person.detected_ip"
                                >
                                    {{person.ip}}
                                </span>
                                <span v-else>
                                    {{person.ip}}
                                </span>
                            </div>
                            <span v-else>
                                -
                            </span>
                        </div>
                    </div>
                </template>

                <template v-slot:guarantee="{guarantee}">
                    <div class="text-center">
                        <vs-icon v-if="guarantee.guarantee" color="success" v-bind="$iconData('icon-check', 'fi-rr-check')"></vs-icon>
                        <vs-icon v-else color="danger" v-bind="$iconData('icon-check', 'fi-rr-cross-small')"></vs-icon>
                    </div>
                </template>

                <template v-slot:autologin="{autologin}">
                    <div class="text-center">
                        <vs-icon v-if="autologin.is_autologin" color="success" v-bind="$iconData('icon-check', 'fi-rr-check')"></vs-icon>
                        <vs-icon v-else color="danger" v-bind="$iconData('icon-check', 'fi-rr-cross-small')"></vs-icon>
                    </div>
                </template>

                <template v-slot:ftd_status="{ftd_status}">
                    <div class="text-center">
                        <vs-icon v-if="ftd_status.ftd_status_declined" v-bind="$iconData('icon-check', 'fi-rr-check')"></vs-icon>
                        <div v-else>-</div>
                    </div>
                </template>

                <template v-slot:country="{country}">
                    <div v-if="country.country && country.country !== undefined && country.country !== 'undefined'"
                         class="flex items-center">
                        <flag width="25" :iso="country.country" type="country"/>
                        <span class="pl-2">{{ country.country }}</span>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:language="{language}">
                    <div v-if="language.language && language.language !== undefined && language.language !== 'undefined'"
                         class="flex items-center">
                        <flag width="25" :iso="language.language" type="language"/>
                        <span class="pl-2">{{ language.language }}</span>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:geo="{geo}">
                    <div v-if="geo.geo && geo.language !== undefined && geo.geo !== 'undefined'" class="flex items-center">
                        <img style="width: 25px" :src="getGeoFlag(geo.geo).flag" alt="">
                        <span class="pl-2 whitespace-no-wrap">{{ geo.geo }}</span>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:advertiser="{advertiser}">
                    <div class="whitespace-no-wrap">{{ advertiser.advertiser || advertiser.advertiser_id || '-' }} /
                        {{ advertiser.integration_name ? advertiser.integration_name : '-' }}
                    </div>
                </template>

                <template v-slot:status="{status}">
                    <div class="flex justify-center">
                        <div v-if="!status.status">-</div>
                        <vs-chip v-else transparent :color="statusColor(status.status)">
                            <span class="whitespace-no-wrap">{{ createName(status.status) }}</span>
                        </vs-chip>
                    </div>
                </template>

                <template v-slot:team="{team}">
                    <div class="flex items-center whitespace-no-wrap">
                        <vs-icon color="primary" v-bind="$iconData('icon-users', 'fi-rr-users')"></vs-icon>
                        <div class="ml-2 whitespace-no-wrap">{{ team.team_name || team.team_id || '-' }}</div>
                    </div>
                </template>

                <template v-slot:affiliate="{affiliate}">
                    <div class="whitespace-no-wrap">{{ affiliate.affiliate_name ? affiliate.affiliate_name : '-' }}</div>
                </template>

                <template v-slot:sms="{sms}">
                    <div v-if="!sms.sms_error && !sms.sms_status && !sms.sms_text">-</div>
                    <div v-else>
                        <p>{{ sms.sms_error }}</p>
                        <p>{{ sms.sms_status }}</p>
                        <p>{{ sms.sms_text }}</p>
                    </div>
                </template>

                <template v-slot:eValidation="{eValidation}">
                    <div v-if="eValidation.errors_validation && Object.keys(eValidation.errors_validation).length">
                        <div class="flex items-center" v-for="(value, key) in eValidation.errors_validation" :key="key">
                            <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                            <div class="whitespace-no-wrap ml-2" v-for="(v, ind) of value" :key="ind">{{ v }}</div>
                        </div>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:a_history="{a_history}">
                    <div v-if="a_history.advertisers_history">
                        <div class="flex items-center" v-if="value" v-for="(value, key) in a_history.advertisers_history"
                             :key="key">
                            <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                            <div class="whitespace-no-wrap ml-2">{{ value }}</div>
                        </div>
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:errorStatus="{errorStatus}">
                    <div v-if="errorStatus.advertiser_response" class="flex items-center">
                        <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                        <div>
                            <div class="whitespace-no-wrap ml-2 textOverflow statusErrorsText">{{ errorStatus.advertiser_response }}</div>
                        </div>
                        <vs-icon
                            class="ml-2 cursor-pointer"
                            color="primary"
                            v-tooltip="$t('tooltip.Copy')"
                            @click.stop.prevent="copy(errorStatus.advertiser_response)"
                            v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                        />
                        <vs-icon
                            v-if="errorStatus.advertiser_response && errorStatus.advertiser_response.length >= 35"
                            class="ml-2 cursor-pointer"
                            color="primary"
                            @click.stop.prevent="errorStatusInfo(errorStatus.advertiser_response)"
                            v-bind="$iconData('icon-eye', 'fi-rr-eye')"
                        />
                    </div>
                    <div v-else>-</div>
                </template>

                <template v-slot:created_at="{created_at}">
                    <div v-if="!created_at.created_at">-</div>
                    <div v-else>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                            <span v-if="created_at.created_at">{{ created_at.created_at|date }}</span>
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                            <span v-if="created_at.created_at">{{ created_at.created_at|time }}</span>
                        </div>
                    </div>
                </template>

                <template v-slot:send_date="{send_date}">
                    <div v-if="!send_date.send_date">-</div>
                    <div v-else>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                            <span v-if="send_date.send_date">{{ send_date.send_date|date }}</span>
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                            <span v-if="send_date.send_date">{{ send_date.send_date|time }}</span>
                        </div>
                    </div>
                </template>

                <template v-slot:first_action_date="{first_action_date}">
                    <div v-if="!first_action_date.first_action_date">-</div>
                    <div v-else>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                            <span v-if="first_action_date.first_action_date">{{first_action_date.first_action_date|date}}</span>
                        </div>
                        <div class="whitespace-no-wrap flex items-center">
                            <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                            <span v-if="first_action_date.first_action_date">{{first_action_date.first_action_date|time}}</span>
                        </div>
                    </div>
                </template>

                <template v-slot:landing="{landing}">
                    <div class="flex items-center">
                        <v-text v-if="landing.domain || landing.landing_url" :text="landing.domain || landing.landing_url">
                            <div class="ml-2 flex items-center" @click="copy(landing.landing_url)">
                                <vs-icon
                                    class="cursor-pointer block"
                                    v-bind="$iconData('icon-link-2', 'fi-rr-link-alt')"
                                    :color="(landing.domain || landing.landing_url) ? 'success' : 'danger'"
                                    v-tooltip="$t('tooltip.Copy')"
                                />
                            </div>
                        </v-text>

                        <div v-else>-</div>
                    </div>
                </template>

                <template v-slot:actions="{actions}">
                    <div class="product-name font-medium truncate flex items-center">
                        <div v-if="actions.status === 'hold' || actions.status === 'not_valid'">
                            <vs-button
                                @click="toTrash([actions.id])"
                                :disabled="loader"
                                radius
                                color="primary"
                                type="flat"
                                v-bind="$iconData('icon-trash-2', 'fi-rr-trash')"
                                v-can="'statistic_lead.update'"
                                v-tooltip="$t('tooltip.toTrash')"
                            ></vs-button>
                        </div>
                        <div class="flex" v-if="actions.status === 'sended'">
                            <template v-if="isPermission('statistic_lead.synchronization_management')">
                                <vs-button
                                  v-if="actions.advertiser_lead_id.includes('_sync_paused_')"
                                  @click="toggleLeadSynchronization(actions.id, true)"
                                  :disabled="loader"
                                  radius
                                  color="primary"
                                  type="flat"
                                  v-bind="$iconData('icon-play', 'fi-rr-play')"
                                  v-tooltip="$t('modals.lead_synchronization_enable')"
                                ></vs-button>

                                <vs-button
                                  v-else
                                  @click="toggleLeadSynchronization(actions.id, false)"
                                  :disabled="loader"
                                  radius
                                  color="primary"
                                  type="flat"
                                  v-bind="$iconData('icon-pause', 'fi-rr-pause')"
                                  v-tooltip="$t('modals.lead_synchronization_disable')"
                                ></vs-button>
                            </template>

                            <vs-button
                                v-if="isPermission('statistic_lead.autologin_info')"
                                @click="autologinInfo(actions.id)"
                                :disabled="loader"
                                radius
                                color="primary"
                                type="flat"
                                v-bind="$iconData('icon-info', 'fi-rr-info')"
                                v-tooltip="$t('modals.autologin_info')"
                            ></vs-button>
                        </div>
                        <div v-if="actions.status === 'hold'">
                            <vs-button
                                radius
                                @click="infoByIntegration(actions)"
                                :disabled="loader"
                                color="primary"
                                type="flat"
                                v-bind="$iconData('icon-info', 'fi-rr-info')"
                                v-can="'statistic_lead.check_lead_integrations'"
                                v-tooltip="$t('modals.Lead_info')"
                            />
                        </div>
                        <div v-if="actions.status !== 'sended' && actions.status !== 'duplicate'">
                            <vs-button
                                v-can="'statistic_lead.update'"
                                @click="edit(actions)"
                                :disabled="loader"
                                radius
                                color="primary"
                                type="flat"
                                v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"
                                v-tooltip="$t('modals.Edit_lead')"
                            ></vs-button>
                        </div>
                    </div>
                </template>
            </ds-table>
        </tabs>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import {dateParse} from '@/utils/mixins'
import {checkPermission} from '@/utils/mixins'
import EventBus from "@/store/eventBus"
import {getLanguages, download, copy} from "@/utils/utils"
import qs from "qs"
import VText from '@/components/Text.vue'

export default {
    mixins: [
        dateParse,
        checkPermission
    ],

    components: {
        VText
    },

    data() {
        return {
            isReindexing: false,
            isMounted: false,
            activeGlobalToTrash: false,
            activeGlobalStatuses: false,
            loader: false,
            fields: [
                {name: 'global.Email', type: 'input', label: 'email', field: 'email', reKey: 'emails'},
                {name: 'modals.Phone', type: 'input', label: 'phone', field: 'phone', reKey: 'phones'},
                {name: 'statistic_fields.id', type: 'input', label: 'id', field: 'id', reKey: 'ids'},
                {name: 'table_filters.manager', type: 'select', label: 'manager_ids', field: 'manager_ids', reKey: 'manager_ids', multiple: true},
                {name: 'table_filters.advertiser_id', type: 'select', label: 'advertisers', field: 'advertisers', reKey: 'advertiser_ids', multiple: true},
                {name: 'table_filters.advertiser_integration_id', type: 'select', label: 'integrations', field: 'integrations', reKey: 'advertiser_integration_ids', multiple: true},
                {name: 'table_filters.traffic_model_id', type: 'select', label: 'traffic_models', field: 'traffic_models', reKey: 'traffic_model_ids', multiple: true},
                {name: 'table_filters.team_id', type: 'select', label: 'teams', field: 'teams', reKey: 'team_ids', multiple: true},
                {name: 'table_filters.affiliate_id', type: 'select', label: 'affiliates', field: 'affiliates', reKey: 'affiliate_ids', multiple: true},
                {name: 'table_filters.group_status', type: 'select', label: 'group_statuses', field: 'group_statuses', multiple: true},
                {name: 'table_filters.language', type: 'select', label: 'languages', field: 'languages', multiple: true},
                {name: 'table_filters.country', type: 'select', label: 'countries', field: 'countries', multiple: true},
                {name: 'table_filters.offer_name', type: 'select', label: 'offer_names', field: 'offer_names', multiple: true},
                {name: 'table_filters.landing_name', type: 'select', label: 'landing_names', field: 'landing_names', multiple: true},
                {name: 'table_filters.geo', type: 'select', label: 'geos', field: 'geos', multiple: true},
                {name: 'table_filters.domain', type: 'select', label: 'domains', field: 'domains'},
                {name: 'table_filters.guarantee', type: 'select', label: 'guarantee', field: 'guarantee', reKey: 'guarantees', can: 'statistic_lead.guarantee'},
                {name: 'table_filters.sub', type: 'input', label: 'sub', field: 'sub', reKey: 'subs'},
            ],
            headsSystem: [
                {name: 'statistic_fields.id', key: 'id', sortKey: 'id', value: 'id', display: true},
                {name: 'statistic.guarantee', key: 'guarantee', sortKey: 'guarantee', value: 'guarantee', headerPosition: 'center', display: true, can: 'statistic_lead.guarantee'},
                {name: 'table.autologin', key: 'autologin', sortKey: 'is_autologin', value: 'autologin', headerPosition: 'center', display: true},
                {name: 'FTD Status', key: 'ftd_status', value: 'ftd_status', translate: 'none', headerPosition: 'center', display: true, can: 'settings_moderation.status'},
                {name: 'global.Lead', key: 'person', sortKey: 'first_name', value: 'person', display: true},
                {name: 'global.Country', key: 'country', sortKey: 'country', value: 'country', display: true},
                {name: 'statistic.Lang', key: 'language', sortKey: 'language', value: 'language', display: true},
                {name: 'global.Geo', key: 'geo', sortKey: 'geo_name',  value: 'geo', display: true},
                {name: 'global.Offer', key: 'offer_name', sortKey: 'offer_name', value: 'offer_name', display: true},
                {name: 'global.Landing', key: 'landing_name', sortKey: 'landing_name', value: 'landing_name', display: true},
                {name: 'global.Domain', key: 'domain', sortKey: 'domain', value: 'landing', display: true},
                {name: 'global.Team', key: 'team', sortKey: 'team_name', value: 'team', display: true},
                {name: 'global.Affiliate', key: 'affiliate_hash', sortKey: 'affiliate_name', value: 'affiliate', display: true},
                {name: 'label.External_price', key: 'external_price', sortKey: 'external_price', value: 'external_price', display: true, can: 'statistic_lead.show_lead_external_price'},
                {name: 'statistic_fields.sub1', key: 'sub1', sortKey: 'sub1', value: 'sub1', display: true},
                {name: 'statistic_fields.sub2', key: 'sub2', sortKey: 'sub2', value: 'sub2', display: true},
                {name: 'statistic_fields.sub3', key: 'sub3', sortKey: 'sub3', value: 'sub3', display: true},
                {name: 'statistic_fields.sub4', key: 'sub4', sortKey: 'sub4', value: 'sub4', display: true},
                {name: 'statistic_fields.sub5', key: 'sub5', sortKey: 'sub5', value: 'sub5', display: true},
                {name: 'statistic_fields.sub6', key: 'sub6', sortKey: 'sub6', value: 'sub6', display: true},
                {name: 'statistic_fields.sub7', key: 'sub7', sortKey: 'sub7', value: 'sub7', display: true},
                {name: 'statistic_fields.sub8', key: 'sub8', sortKey: 'sub8', value: 'sub8', display: true},
                {name: 'statistic_fields.sub9', key: 'sub9', sortKey: 'sub9', value: 'sub9', display: true},
                {name: 'statistic_fields.sms', key: 'sms_status', value: 'sms', display: true},
                {name: 'statistic.ADV_INT', key: 'advertiser_integration_id', sortKey: 'advertiser_name', value: 'advertiser', display: true},
                {name: 'statistic.External_status', key: 'advertisers_lead_status', sortKey: 'advertisers_lead_status', value: 'advertisers_lead_status', display: true, can: 'settings_advertiser.show_advertisers_lead_status'},
                {name: 'statistic.SYS_Status', key: 'status', value: 'status', display: true},
                {name: 'statistic.ERR_Status', key: 'advertiser_response', sortKey: 'advertiser_response', value: 'errorStatus', display: true},
                {name: 'statistic.Validation_errors', key: 'errors_validation', sortKey: 'errors_validation', value: 'eValidation', display: true},
                {name: 'global.ADV_history', key: 'advertisers_history', sortKey: 'advertisers_history', value: 'a_history', display: true},
                {name: 'statistic.ADV_Status', key: 'group_status', sortKey: 'group_status', value: 'group_status', display: true},
                {name: 'statistic.Reg_date', key: 'created_at', sortKey: 'created_at', value: 'created_at', display: true},
                {name: 'global.Send_date', key: 'send_date', sortKey: 'send_date', value: 'send_date', display: true},
                {name: 'global.Action_date', key: 'first_action_date', sortKey: 'first_action_date', value: 'first_action_date', display: true},
                {name: 'global.Actions', value: 'actions', headerPosition: 'right', display: true}
            ],
            csvFields: [
                'email',
                'country',
                'team_name',
                'offer_name',
                'offer_id',
                'domain',
                'landing_name',
                'group_status',
                'send_date',
                'first_action_date',
                'sub1',
                'sub2',
                'sub3',
                'sub4',
                'sub5',
                'sub6',
                'sub7',
                'sub8',
                'sub9',
                'advertiser_name',
                'advertisers_history',
                'integration_id',
                'integration_name'
            ],
            heads: [],
            date: {
                created_at: {startDate: new Date(), endDate: new Date()},
                send_date: {startDate: new Date(), endDate: new Date()},
                first_action_date: {startDate: new Date(), endDate: new Date()},
            },
            direction: 'send_date',
            filtersData: {},
            leads: [],
            pageNum: 1,
            limitNum: 50,
            totalNum: 1,
            status: 'sended',
            statusSystem: 'sended',
            activeTab: 0,
            statusList: [],
            orderBy: {name: "id", direction: "desc"},
            selectDateSystem: {
                start: this.dateParse(new Date()),
                end: this.dateParse(new Date()),
                direction: 'send_date'
            },
            selectDate: {
                start: this.dateParse(new Date()),
                end: this.dateParse(new Date()),
                direction: 'send_date'
            },
            filter: {},
            leadTrashIds: [],
            statusIds: [],
            count: 0
        }
    },

    computed: {
        isTableSelect() {
            return this.isReindexing
                || (this.activeGlobalToTrash
                    && ['hold', 'not_valid'].includes(this.statusSystem))
                || (this.activeGlobalStatuses && this.statusSystem === 'sended')
        },

        isAdv() {
            return this.userState.group === 2 ||
                this.userState.team.is_internal ||
                this.isPermission('statistic_lead.advertiser')
        },

        userState() {
            return this.$store.getters.userState
        },

        csvFieldNames() {
            const template = {
                person: ['email'],
                advertiser: ['integration_id', 'integration_name', 'advertiser_name'],
                offer_name: ['offer_name', 'offer_id'],
            }

            const list = this.heads
                .filter(item => item.display)
                .flatMap(item => template[item.value] || [item.sortKey || item.key])

            return list.filter(item => this.csvFields.includes(item))
        }
    },

    watch: {
        '$i18n.locale'() {
            if (this.filtersData.guarantee && this.filtersData.guarantee.length) {
                this.filtersData.guarantee = this.guaranteeLocale(this.filtersData.guarantee)
            }
        },

        direction(direction) {
            this.resetDate()

            this.selectedDate({
                ...this.date[direction],
                direction: direction
            })
        }
    },

    methods: {
        selectedTable(ids) {
            if (this.statusSystem === 'not_valid' || this.statusSystem === 'hold') {
                this.leadTrashIds = ids
            } else if (this.statusSystem === 'sended') {
                this.statusIds = ids
            }
        },

        async updateGroupStatusOrReindexing(action) {
            if (!this.statusIds.length) {
                if (action === 'updateStatus') {
                    this.activeGlobalStatuses = true
                } else {
                    this.isReindexing = true
                }

                return
            }

            try {
                if (!this.isReindexing) {
                    EventBus.$emit('emitPopupEvent', {
                        type: 'updateLeadStatuses',
                        name: this.$t('tooltip.updateStatus'),
                        data: this.statusIds,
                        width: '300px'
                    })

                    return
                }

                await send(this.$url.statistic.reindex, 'PATCH', {
                    data: {
                        lead_ids: this.statusIds
                    }
                })

                this.updateGroupStatusOrReindexingClose()
                await this.refreshTable()
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        updateGroupStatusOrReindexingClose() {
            this.$set(this, 'statusIds', [])
            if (this.$refs.table) {
                this.$refs.table.clearSelect()
            }
            this.activeGlobalStatuses = false
            this.isReindexing = false
        },

        errorStatusInfo(data) {
            EventBus.$emit('emitPopupEvent', {type: 'errorStatusInfo', name: this.$t('statistic.ERR_Status'), data: data})
        },

        copyData(data) {
            return JSON.parse(JSON.stringify(data))
        },

        copy(data) {
            if (data) {
                copy(data)

                const icon = this.$iconData('icon-check', 'fi-rr-check')
                this.$vs.notify({
                    time: 18000,
                    title: 'Success!',
                    text: this.$t('notification.success'),
                    color: 'success',
                    iconPack: icon['icon-pack'],
                    icon: icon.icon
                })
            }
        },

        async page(page, filter = false) {
            if (this.pageNum !== page) {
                this.pageNum = page
                await this.get(filter)
            }
        },

        async limit(limit) {
            if (limit !== this.limitNum) {
                this.limitNum = limit

                if (this.pageNum !== 1) {
                    await this.page(1, false)
                } else {
                    await this.get(false)
                }
            }
        },

        async sort(sort) {
            this.orderBy =  {
                name: sort.name,
                direction: sort.type
            }

            await this.get(false)
        },

        async view(data) {
            try {
                data.display = !data.display

                const display = this.heads.reduce((res, acc) => {
                    res[acc.value] = acc.display
                    return res
                }, {})

                await send(this.$url.user['change-fields'], 'PUT', {
                    data: {fields: JSON.stringify(display)}
                })

                this.$store.commit('SET_USER_FIELDS', {
                    event: data.value,
                    display: data.display
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async refreshTable() {
            await this.get()
        },

        resetDate(direction) {
            Object.keys(this.date).map(key => {
                if (direction !== key) {
                    this.date[key].startDate = new Date()
                    this.date[key].endDate = new Date()
                }
            })
        },

        selectedDate(date) {
            this.resetDate('created_at')
            this.resetDate('send_date')
            this.resetDate('first_action_date')

            this.date[date.direction].startDate = date.startDate
            this.date[date.direction].endDate = date.endDate

            this.selectDateSystem = {
                direction: date.direction,
                start: this.dateParse(date.startDate),
                end: this.dateParse(date.endDate)
            }
        },

        async comments(data) {
            try {
                const params = {
                    id: data.id
                }

                const comments = await send(`${this.$url.statistic.get_lead_comments}`, 'GET', {params})
                    .then(data => data.data.result.comment)

                EventBus.$emit('emitPopupEvent', {
                    type: 'commentLead',
                    name: this.$t('modals.Lead_comments'),
                    ids: {content: comments ? comments : [], email: data.email}
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getHistoryStatuses(data) {
            try {
                const params = {
                    id: data.id
                }

                const leadHistoryStatuses = await send(this.$url.statistic.get_lead_history_statuses, 'GET', {params})
                    .then(data => data.data.result.lead_history_statuses)

                EventBus.$emit('emitPopupEvent', {
                    type: 'leadHistoryStatuses',
                    name: this.$t('modals.Lead_history_statuses'),
                    ids: leadHistoryStatuses
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        getGeoFlag(geo) {
            return getLanguages(geo)
        },

        statusColor(status) {
            const template = {
                hold: '#FF9F43',
                sended: '#28C76F',
                not_valid: '#CCCCCC',
                trash: '#EA5455',
                duplicate: '#CCCCCC',
                sended_false: '#cc3bec',
            }

            return template[status] ? template[status] : '#CCCCCC'
        },

        createName(name) {
            if (name) {
                const str = name.split('_').join(' ')
                return str[0].toUpperCase() + str.slice(1)
            } else {
                return '-'
            }
        },

        toTrashGlobalClose() {
            this.leadTrashIds = []
            this.$refs.table.clearSelect()
            this.activeGlobalToTrash = false
        },

        toTrashGlobal(ids) {
            if (!this.activeGlobalToTrash) {
                this.activeGlobalToTrash = true
            } else {
                this.toTrash(ids, true)
            }
        },

        toTrash(ids, action) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: this.$t('modals.Send_to_trash'),
                accept: async () => {
                    try {
                        await send('/statistic/trash', 'PUT', {params: {id: ids}})

                        const page = Math.ceil((this.totalNum - ids.length) / this.limitNum)

                        if (page < this.pageNum) {
                            await this.page(page, true)
                        } else {
                            await this.get(true)
                        }

                        this.leadTrashIds = []
                        this.$refs.table.clearSelect()

                        if (action) {
                            this.activeGlobalToTrash = false
                        }
                    } catch (e) {
                        new ErrorHandler(e).send
                    }
                },
                acceptText: this.$t('statistic_fields.send'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async downloadCSV() {
            try {
                const params = {
                    ...this.selectDate,
                    limit: 500000,
                    page: this.pageNum,
                    status: this.status,
                    order: this.orderBy,
                    filters: Object.fromEntries(Object.entries({ ...this.filter }).map(([key, val]) => [
                        key,
                        ['emails', 'ids'].includes(key) ? this.inputParse(val) : (typeof val === 'string' || val === null) ? [val] : val
                    ])),
                    columns: this.csvFieldNames
                }

                if (!params.order.direction) {
                    params.order = {name: 'id', direction: 'desc'}
                }

                const response = await send(this.$url.statistic.exportcsv, 'GET', {
                    params,
                    paramsSerializer: params => qs.stringify(params, {
                        encode: false,
                        indices: false,
                        arrayFormat: 'brackets',
                    })
                })

                download(response.data, `${params.start} - ${params.end}.csv`, 'text/csv')
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        infoByIntegration(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'leadInfoIntegration',
                name: this.$t('modals.Lead_info_integration'),
                ids: data.id,
                full: true
            })
        },

        autologinInfo(id) {
            EventBus.$emit('emitPopupEvent', {
                type: 'autologinInfo',
                name: this.$t('modals.autologin_info'),
                data: id,
                width: 'auto'
            })
        },

        async toggleLeadSynchronization(id, isEnable) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: isEnable ? this.$t('modals.lead_synchronization_enable') : this.$t('modals.lead_synchronization_disable'),
                accept: async() => {
                    try {
                        await send(`/statistic/leads/${id}/synchronization-management`, 'PATCH')

                        await this.refreshTable()
                    } catch (e) {
                        new ErrorHandler(e).send
                    }
                },
                acceptText: this.$t('global.Save'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async edit(data) {
            EventBus.$emit('emitPopupEvent', {type: 'editLead', name: this.$t('modals.Edit_lead'), ids: data.id})
        },

        async selectedTab(index) {
            const {event} = this.statusList[index]
            this.status = event

            if (this.pageNum === 1) {
                await this.get(true)
            } else {
                await this.page(1, true)
            }

            this.activeTab = index
            this.statusSystem = event

            this.leadTrashIds = []

            this.updateGroupStatusOrReindexingClose()
            this.activeGlobalToTrash = false
        },

        async submitFilter(data) {
            this.filter = this.copyData(data)
            this.selectDate = this.selectDateSystem

            Object.keys(this.filter).map(key => {
                if (Array.isArray(this.filter[key])) {
                    this.filter[key] = this.filter[key].map(item => {
                        if (/^[-]$/.test(item))
                            item = null
                        return item
                    })
                } else {
                    if (/^[-]$/.test(this.filter[key]))
                        this.filter[key] = null
                }
            })

            if (this.pageNum !== 1) {
                await this.page(1, true)
            } else {
                await this.get()
            }

            this.updateGroupStatusOrReindexingClose()
        },

        async refreshFilter(get = true) {
            this.resetDate()
            this.selectedDate({
                ...this.date.send_date,
                direction: 'send_date'
            })

            this.selectDate = this.selectDateSystem

            this.filter = {}

            if (get) {
                await this.get()
                this.updateGroupStatusOrReindexingClose()
            }
        },

        guaranteeLocale() {
            return [
                {name: this.$t('global.no_guarantee'), id: '0'},
                {name: this.$t('global.guarantee'), id: '1'}
            ]
        },

        landingUrl(str) {
            if (!str) return str

            return str.replace(/^https?:\/\//, '')
                .replace(/[\/?].*/, '')
                .replace(/^https?%3A%2F%2F/, '')
                .replace(/((%2F)|(%3F)).*/, '')
        },

        replaceNullToString(data) {
            Object.entries(data).map(([key, value]) => {
                data[key] = value.map(item => item === null ? '-' : item)
            })

            return data
        },

        domainMutation(data) {
            return data ? data.map(item => this.landingUrl(item)) : []
        },

        createTabs(count) {
            return [
                'sended',
                'hold',
                'not_valid',
                'trash',
                'double',
                'sended_false',
            ].map(name => ({
                name: `leadCount.${name}`,
                count: count[name],
                event: name
            }))
        },

        showByStatus(status) {
            const heads = this.copyData(this.headsSystem)

            const templateHide = {
                sended: ['eValidation'],
                trash: ['eValidation', 'external_price'],
                duplicate: ['actions', 'eValidation', 'guarantee', 'external_price'],
                hold: ['guarantee', 'external_price'],
                not_valid: ['guarantee', 'external_price'],
                sended_false: ['guarantee', 'external_price'],
            }

            if (!this.isPermission('statistic_lead.autologin_info') && !this.isPermission('statistic_lead.synchronization_management')) {
                templateHide.sended.push('actions')
            }

            if (templateHide[status]) {
                return heads.filter(head => !templateHide[status].includes(head.value) && this.isPermission(head.can))
            } else {
                return heads
            }
        },

        parseJSON(data) {
            try {
                return JSON.parse(data)
            } catch (e) {
                return data
            }
        },

        async getLeads(params = {}) {
            try {
                return await send(this.$url.statistic.get, 'GET', {
                    params,
                    paramsSerializer: params => qs.stringify(params, {
                        encode: false,
                        indices: false,
                        arrayFormat: 'brackets',
                    }),
                }).then(response => response.data.result)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getCount(params = {}) {
            try {
                const obj = {...params}

                delete obj.limit
                delete obj.page
                delete obj.order

                return await send(this.$url.statistic['lead-count'], 'GET', {
                    params: obj,
                    paramsSerializer: params => qs.stringify(params, {
                        encode: false,
                        indices: false,
                        arrayFormat: 'brackets',
                    }),
                }).then(response => response.data.result.counts)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        inputParse(email = '') {
            return email.split(/\s/)
                .filter(item => item)
                .map(item => item.trim())
        },

        async get(required_filter = true) {
            try {
                this.loader = true

                const params = {
                    ...this.selectDate,
                    limit: this.limitNum,
                    page: this.pageNum,
                    status: this.status,
                    order: {...this.orderBy},
                    filters: {...this.filter}
                }

                if (!params.order.direction) {
                    params.order = {name: 'id', direction: 'desc'}
                }

                const keys = ['emails', 'ids']
                keys.map(key => {
                    if (params.filters[key]) {
                        params.filters[key] = this.inputParse(params.filters[key].trim())
                    }
                })

                params.filters = Object.entries(params.filters).reduce((res, [key, value]) => {
                    if (key === 'guarantees') {
                        value = ~~value
                    }

                    res[key] = !Array.isArray(value) ? [value] : value

                    return res
                }, {})

                const [leads, count] = await Promise.all([
                    this.getLeads(params),
                    this.getCount(params)
                ])

                if (required_filter) {
                    leads.filters = {...leads.filters, ...leads.filters.additional}

                    if (!leads.filters.additional.manager_ids) this.fields = this.fields.filter(item => item.field !== 'manager_ids')

                    delete leads.filters.additional

                    leads.filters = this.replaceNullToString(leads.filters)
                    // leads.filters.domains = this.domainMutation(leads.filters.domain)
                    leads.filters.affiliates = leads.filters.affiliates.map(item => ({...item, name: `${item.team_name || item.team_id} / ${item.name}`}))

                    leads.filters.integrations = leads.filters.integrations.map(item => {
                        return {...item, name: `${item.advertiser_name || item.advertiser_id} / ${item.name}`}
                    })
                    leads.filters.guarantee = leads.leads.length ? this.guaranteeLocale() : []

                    this.statusList = this.createTabs(count)
                    const status = this.statusList
                        .find(item => item.event === params.status)

                    this.heads = this.showByStatus(status.event)

                    if (this.userState.lead_statistic_fields) {
                        const display = this.parseJSON(this.userState.lead_statistic_fields)

                        this.heads.forEach(head => {
                            if (display.hasOwnProperty(head.value)) head.display = display[head.value]
                            return head
                        })
                    }

                    this.totalNum = status.count
                    this.filtersData = leads.filters
                }

                if (this.userState.group !== 2) {
                    this.heads = this.heads.filter(item => item.value !== 'ftd_status')
                }

                this.leads = leads.leads
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loader = false
            }
        }
    },

    async mounted() {
        await this.get()

        if (!this.isAdv) {
            const template = [
                'advertisers',
                'integrations'
            ]

            this.fields = this.fields.filter(filter => !template.includes(filter.field))
            this.heads = this.heads.filter(head => !template.includes(head.value))
        }

        if (!(this.userState.team.is_internal || this.userState.group === 2)) {
            this.heads = this.heads.filter(item => item.value !== 'a_history')
        }

        if (!this.isPermission('settings_team.show_team_name')) {
            const index = this.fields.findIndex(item => item.field === 'teams')
            this.$set(this.fields[index], 'sоrtKey', 'id')
        }

        if (!this.isPermission('settings_advertiser.show_advertiser_name') && this.isPermission('statistic_lead.advertiser')) {
            const index = this.fields.findIndex(item => item.field === 'advertisers')
            this.$set(this.fields[index], 'sоrtKey', 'id')
        }

        this.isMounted = true

        EventBus.$on('updateLeads', async (lead) => {
            await this.refreshTable()
        })

        EventBus.$on('reloadTable', async () => {
            await this.get()
        })

        EventBus.$on('doneStatusMapping', async () => {
            this.updateGroupStatusOrReindexingClose()
            await this.refreshTable()
        })
    },

    destroyed() {
        EventBus.$off('updateLeads')
        EventBus.$off('doneStatusMapping')
        EventBus.$off('reloadTable')
    }
}
</script>

<style lang="scss">
.leads {
    &__detected_ip {
        color: rgba(var(--vs-danger), 1);
    }
}

.statusErrorsText {
    max-width: 250px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.vs-dropdown--custom {
    max-height: 400px;
    overflow-y: auto;
    height: 100%;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-track {
        background: white;
    }

    &::-webkit-scrollbar-thumb {
        background: #cdcdcd;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #b3b3b3;
    }
}
</style>
